<template>
<NoticeCenter pageType="page"/>
</template>

<script>
import NoticeCenter from '../../components/notice/notice-center'
export default {
    components: { NoticeCenter }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/notice/index.vue